<template>
  <div>
  <v-toolbar flat color="white">
    <v-toolbar-title>Catálogo</v-toolbar-title>
    <v-divider
      class="mx-2"
      inset
      vertical
    ></v-divider>
    <v-spacer></v-spacer>
    <v-btn color="primary" dark class="mb-2" @click="nuevoRegistro()">Nuevo</v-btn>
  </v-toolbar>
  <v-data-table
    :headers="headers"
    :items="datos.data"
    :pagination.sync="pagination"
    :total-items="totalRegistros"
    :loading="loading"
    rows-per-page-text="Filas por página"
  >
    <template slot="items" slot-scope="props">
      <td>{{ props.item.fila[1] }}</td>
      <td class="">{{ props.item.fila[2] }}</td>
      <td class="">{{ props.item.fila[3] }}</td>
      <td class="">{{ props.item.fila[4] }}</td>
      <td v-if="seleccionar === undefined || seleccionar === false" class="justify-center layout px-0">
        <v-icon
          small
          class="mr-2"
          @click="verRegistro(props.item)"
        >
          open_in_browser
        </v-icon>
      </td>
      <td v-if="seleccionar === true" class="justify-center layout px-0">
        <v-icon
          small
          class="mr-2"
          @click="enviarRegistro(props.item)"
        >
          check_box_outline_black
        </v-icon>
      </td>
    </template>
    <template slot="no-data">
      <v-btn color="primary" @click="initialize">No data</v-btn>
    </template>
  </v-data-table>
  <v-dialog v-model="ventanaRegistro" max-width="60%">
    <catalogo v-on:cerrar="cerrarRegistro" v-on:listar="listar" v-bind:ubigeo="ubigeo" v-bind:idRegistro="idCatalogoActual">
    </catalogo>
  </v-dialog>
</div>
</template>

<script>
import mixin from '../mixins.js'

export default {
  mixins: [mixin],
  name: 'catalogo-lista',
  props: {
    ubigeo: {},
    seleccionar: false
  },
  data: () => ({
    ventanaRegistro: false,
    totalRegistros: 0,
    loading: false,
    pagination: {},
    headers: [
      { text: 'Artículo', value: 1 },
      { text: 'Unidad', value: 1 },
      { text: 'Marca', value: 2 },
      { text: 'Modelo', value: 3 },
      { text: 'Acciones', align: 'center', value: '', sortable: false }
    ],
    datos: [],
    idCatalogoActual: ''
  }),
  watch: {
    ventanaRegistro () {
      if (this.ventanaRegistro === false) {
        this.idCatalogoActual = ''
      }
    },
    pagination: {
      handler () {
        if (this.loading === false) {
          let descendente = 0
          if (this.pagination.descending) {
            descendente = 1
          }
          this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page)
        }
      },
      deep: true
    }
  },
  created () {
    this.initialize()
    this.pagination.rowsPerPage = 10
  },
  methods: {
    initialize () {
      this.datos = {}
    },
    apiListaRegistros (idx, ord, pagina) {
      var solicitudApi = this.crearSolicitud()
      if (this.datos.pagina === undefined) {
        pagina = 0
      }
      this.loading = true
      var datos = {
        tipo: 'lista',
        nfilas: this.pagination.rowsPerPage,
        idx: idx,
        ord: ord,
        pag: pagina
      }
      solicitudApi.datos = datos
      const myRequest = new Request(`${process.env.NODE_API}catalogo/listar`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            this.datos = datos.d
            this.totalRegistros = this.datos.registros
            if (parseInt(this.datos.pagina) !== parseInt(this.pagination.page)) {
              this.pagination.page = parseInt(this.datos.pagina)
            }
            this.loading = false
          }
        })
    },
    verRegistro (item) {
      this.idCatalogoActual = item.id
      this.ventanaRegistro = true
    },
    nuevoRegistro () {
      this.idCatalogoActual = 0
      this.ventanaRegistro = true
    },
    cerrarRegistro () {
      this.ventanaRegistro = false
    },
    listar () {
      if (this.loading === false) {
        let descendente = 0
        if (this.pagination.descending) {
          descendente = 1
        }
        this.apiListaRegistros(this.pagination.sortBy, descendente, this.pagination.page)
      }
    },
    enviarRegistro (item) {
      this.$emit('seleccionado', item)
    }
  }
}
</script>

<style>
.v-btn--floating .v-icon {
    height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/CatalogoLista.vue